import { Page } from '@/core/architecture'

import { ConsoleOfficialInformationEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleOfficialInformationEdit Page
 * Implemented as a practical sample.
 */
export const ConsoleOfficialInformationEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleOfficialInformationEditTemplate state={state} {...actions} />
}
